import React from "react";
import { Formik } from "formik";
import {
    TextField, withStyles, Button, Typography,
    Select,
    MenuItem,
    FormControl,
    CircularProgress,
    InputLabel
} from "@material-ui/core";
import * as Yup from "yup";


const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        margin: theme.spacing(2),
    },
    submit: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        width: "120px",
        marginTop: "10px"
    },
    formControl: {
        width: "100%"
    },

    buttons: {
        textAlign: "right",
        width: '100%'
    }
});

const UnpairedPaletteForm = props => {
    const { classes, formSettings, initialValues, loading, handleSubmit, translations } = props;
    return (
        <div className={classes.root}>
            <Formik
                initialValues={initialValues}
                onSubmit={(values, { setSubmitting }) => {
                    setSubmitting(true);
                    handleSubmit(values);
                }}
                validationSchema={Yup.object().shape(formSettings.Validation)}
            >
                {formikProps => {
                    const { values, touched, errors, isValid, dirty, isSubmitting, handleChange, handleBlur, handleSubmit } = formikProps;
                    return (
                        <form onSubmit={handleSubmit}>
                            {formSettings.FormTitle ? <Typography variant={"h6"}>  {formSettings.FormTitle}</Typography> : null}
                            {formSettings.SecondTitle ? <Typography variant={"inherit"}>  {formSettings.SecondTitle}</Typography> : null}<br />
                            {formSettings.ThirdTitle ? <Typography variant={"inherit"}>  {formSettings.ThirdTitle}</Typography> : null}
                            {formSettings.ReportData ?
                                <FormControl className={classes.formControl} margin={"dense"}>
                                    <InputLabel shrink>{translations['type_unpaired_text'] || "Please select external data type"}</InputLabel>
                                    <Select
                                        name="Type"
                                        label={translations["report_information"] || "Report information"}
                                        margin={"dense"}
                                        value={values.Type}
                                        onChange={handleChange}
                                    >
                                        <MenuItem key={'Order'} value={'Order'}>
                                            {translations['order'] || 'Order'}
                                        </MenuItem>
                                        <MenuItem key={'TransportColli'} value={'TransportColli'}>
                                            {translations['transport_colli'] || 'Transport Colli'}
                                        </MenuItem>
                                        <MenuItem key={'Colli'} value={'Colli'}>
                                            {translations["colli"] || "Colli"}
                                        </MenuItem>
                                    </Select>
                                </FormControl> : null}
                            <TextField
                                name="ExternalID"
                                value={values.ExternalID}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.ExternalID && touched.ExternalID)}
                                placeholder={translations['external_id'] || 'ExternalID'}
                                label={translations['external_id'] || 'ExternalID'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <div className={classes.buttons}>
                                {formSettings.ButtonSubmit ? (
                                    <Button
                                        className={classes.submit}
                                        variant="contained"
                                        color={formSettings.ButtonSubmit.Color}
                                        type="submit"
                                        disabled={isSubmitting || loading || !(isValid && dirty)}
                                    >{isSubmitting ? <CircularProgress size={24} /> : formSettings.ButtonSubmit.Title}
                                    </Button>
                                ) : null}
                            </div>
                        </form>
                    );
                }}
            </Formik>
        </div>
    );
};

export default withStyles(styles, { withTheme: true })(UnpairedPaletteForm);
